import { createUpdateSyncSlice } from '@sonar-software/xuder';
import { defaultApplicationsIdMapState } from './state';

import {
	DataSecurityApplicationReference,
	DataSecurityApplicationStatus,
	UpdateDataSecurityApplicationReferenceRequest
} from '@types';

const empty: DataSecurityApplicationReference = {
	activityPeriod: 0,
	installed: false,
	integrationUser: '',
	monitors: [],
	name: '',
	status: DataSecurityApplicationStatus.Added
};

function rebuildReferenceEntry(
	entry: UpdateDataSecurityApplicationReferenceRequest,
	existingEntry: DataSecurityApplicationReference
): DataSecurityApplicationReference {
	return {
		...existingEntry,
		...entry
	};
}

export const coreDataSecurityApplicationsIdMapSlice = createUpdateSyncSlice({
	name: 'CoreSonarObjectsIdMap',
	state: defaultApplicationsIdMapState,
	transform: (action: Array<UpdateDataSecurityApplicationReferenceRequest>, state = {}) => {
		if (!action.length) {
			return state;
		}

		const updatedState: typeof state = {
			...state
		};

		for (const entry of action) {
			const key = entry.applicationId;

			updatedState[ key ] = rebuildReferenceEntry(entry, state[ key ] ?? { ...empty });
		}

		return updatedState;
	}
});
